export const PREVIEW_PRODUCTS_SEARCH_PAGE_SIZE = 40;
export var PreviewModelType;
(function (PreviewModelType) {
    PreviewModelType["Rules"] = "rules";
    PreviewModelType["BiasingStrategies"] = "biasing";
})(PreviewModelType || (PreviewModelType = {}));
export var PreviewType;
(function (PreviewType) {
    PreviewType["Browse"] = "browse";
    PreviewType["Query"] = "query";
})(PreviewType || (PreviewType = {}));
export var FacetNavigationType;
(function (FacetNavigationType) {
    FacetNavigationType["Value"] = "VALUE";
    FacetNavigationType["Range"] = "RANGE";
})(FacetNavigationType || (FacetNavigationType = {}));
export const CATEGORIES_FACET_NAVIGATION = 'categories';
